import React, { Component } from "react";
import FieldValidationProvider from "../../Helpers/FieldValidator/FieldValidationProvider";

class SignupForm extends Component {

    render() {
        const { step, validity } = this.props;
        const PageFields = step.PageFields;
        return (
            <FieldValidationProvider validity={validity || {}}>
                <div className="Content-form">
                    <PageFields {...step.props} {...this.props} />
                </div>
            </FieldValidationProvider>
        );
    }

}

export default SignupForm;